import ReviewsPage from './[page]';

export default ReviewsPage;
